<script setup>
import { computed, watch } from 'vue';
import { useCrm } from 'dashboard/composables/useCrm';
import { useUISettings } from 'dashboard/composables/useUISettings';

const props = defineProps({ conversationId: { type: Number, required: true } });
const id = computed(() => props.conversationId);
const { state, active, load } = useCrm(id);
const { updateUISettings } = useUISettings();
const stage = computed(() => {
  const funnel = state.value.data?.funnels.find(
    f => f.id === active.value?.funnel_id
  );
  return (active.value?.state.stages || funnel?.columns)?.find(
    s => s.id === active.value?.column_id
  )?.name;
});
watch(id, load, { immediate: true });
const open = () =>
  updateUISettings({
    is_contact_sidebar_open: true,
    is_copilot_panel_open: false,
    crm_sidebar_tab: 'service',
  });
</script>

<template>
  <button
    v-if="state.data"
    class="max-w-28 truncate md:max-w-44 rounded-lg border border-n-weak px-3 py-2 text-sm text-n-slate-12 hover:bg-n-alpha-2"
    :class="{
      'text-n-ruby-11':
        active?.deadline_at && new Date(active.deadline_at) < new Date(),
    }"
    @click="open"
  >
    {{ $t('CRM.stage') }}: {{ stage || $t('CRM.notStarted') }}
  </button>
</template>
